import Vue from 'vue';
import { Indicator, MessageBox, InfiniteScroll } from 'mint-ui';
import { Toast } from 'vant';
Vue.use(InfiniteScroll);
Vue.$loading = Vue.prototype.$loading = Indicator;
Vue.$message = Vue.prototype.$message = MessageBox;
Vue.use(Toast);
